@if (openModalRedirecionamento()) {
  <vivest-modal
    heading="Solicitação recebida com sucesso"
    [hasIcon]="false"
    [open]="openModalRedirecionamento()"
    position="top"
  >
    <!-- O vivest-modal só exibe conteúdo nos slots icon, heading, description e actions. -->
    <div slot="description">
      <p class="mb-0 text-start">Sua solicitação de opção de instituto e a documentação foram recebidas com sucesso. 
        Daremos continuidade ao processamento da solicitação. Em caso de dúvidas, entre em contato com a Central de Relacionamento.</p>
    </div>
    <vivest-button slot="actions" variant="primary" size="md" (click)="irParaComprovante()">
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Documento da Solicitação
    </vivest-button>
  </vivest-modal>
} @else if (dadosCarregados()) {
<div class="container mt-3">
  <vivest-tag type="status" variant="warning" class="tag">
    Pendente
  </vivest-tag>
  <h2>Escolha seu Instituto Previdenciário</h2>
  <p class="top-16">
    A previdência complementar é um investimento para o futuro. Se você sair do emprego antes de se aposentar, poderá escolher o que fazer com os recursos acumulados,
    conforme as regras do plano. São quatro opções, chamadas de institutos previdenciários: autopatrocínio e Benefício Proporcional Diferido (BPD), para manter o vínculo
    com o plano, ou portabilidade e resgate, para encerrá-lo. Essas opções valem tanto para quem pede demissão quanto para quem é demitido.
  </p>
  <div class="cards-grid">
    <vivest-card variant="elevated" full-width>
      <div class="card-content">
        <div class="card-icon">
          <img src="assets/images/icons/calendar.svg" alt="calendar icon">
        </div>
        <div class="card-info">
          <span class="card-label">Data limite para escolha:</span>
          <span class="card-text">{{ dataLimite() !== null ? (dataLimite() | date: 'dd/MM/yyyy') : 'Instituto previdenciário não iniciado' }}</span>
        </div>
      </div>
    </vivest-card>
    <!-- <vivest-card variant="elevated" full-width>
      <div class="card-content">
        <div class="card-icon">
          <img src="assets/images/icons/calendar.svg" alt="calendar icon">
        </div>
        <div class="card-info">
          <span class="card-label">Data de Adesão:</span>
          <span class="card-text">01/01/2024</span>
        </div>
      </div>
    </vivest-card> -->
  </div>
  <h4>Como funciona?</h4>
  <p class="top-32">
    Você consegue por esse serviço consultar o seu Extrato de Desligamento, que contém os valores e informações para cada instituto, e selecionar um
    dos institutos previdenciários. Saiba mais sobre eles abaixo:
  </p>
  <div class="types-container">
    <div>
      Autopatrocínio
      <p>
        Você mantém o vínculo com o plano e continua contribuindo, assumindo também as contribuições que eram feitas pela empresa.
      </p>
    </div>
    <div>
      Benefício Proporcional Diferido (BPD)
      <p>
        Você deixa os recursos no plano, sem fazer as contribuições regulares, para receber um benefício no futuro. Pode haver
        cobrança de despesas e coberturas previstas no regulamento.
      </p>
    </div>
    <div>
      Resgate
      <p>
        Você recebe o valor disponível para resgate e encerra o vínculo com o plano, conforme as regras do regulamento e a
        tributação aplicável.
      </p>
    </div>
    <div>
      Portabilidade
      <p>
        Você transfere os recursos para outro plano de previdência, conforme as regras aplicáveis, e continua investindo na sua aposentadoria.
      </p>
    </div>
  </div>
  <div class="d-flex justify-content-center buttons top-64">
    <vivest-button variant="primary" size="md" (click)="onSubmit()">
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Abrir Extrato de Desligamento
    </vivest-button>
  </div>
</div>
}
